export const OTA_BED_STATUS_TOOLTIP = {
  'Scheduled': 'Device is scheduled for an update.',
  'Queued': 'Update Task has been initiated.',
  'Downloading': 'Package is downloading.',
  'DownloadSuccess': 'Package download completed.',
  'DownloadFailed': 'Package download failed.',
  'Delivering': 'Package is downloading.',
  'Delivery Success': 'Package download completed.',
  'Delivery Failed': 'Package download failed.',
  'Delivery Cancelled': 'OTA task aborted.',
  'Staging': 'Gateway staging.',
  'BedStaging': 'Display is downloading a package from Gateway.',
  'BedIdle': 'NO BED ACTIVITY.',
  'Idle': 'Gateway is idle.',
  'UserAckAwaited': 'An update is ready, and the display is waiting for a user to initiate the update.',
  'CortexNodesUpdating': 'Cortex nodes are updating \n (Main Controller, Brake, RIB, Zoom, Motion).',
  'GatewayUpdating': "Gateway is updating as part of the manual update started by the user \n (this will only occur if Gateway's auto update failed previously).",
  'GatewayRebooting': 'Gateway is rebooting.',
  'GatewayUpdateSuccess': 'Gateway update successful.',
  'GatewayUpdateAbort': 'Gateway update failed.',
  'DisplayUpdating': 'Display is updating.',
  'ProductUpdateReboot': 'Updates are done; the bed is resetting.',
  'ProductUpdateSuccess': 'The update was successful.',
  'ProductUpdateFail': 'The update (including the retry) failed.',
  'UserAckAwaitedforRetry': 'Waiting for user acknowledgement.',
  'BootloaderUpdateSucess': 'Gateway update successful.',
  'InvalidDeviceID': 'Invalid Device Id detected due to possible reasons i.e.  Footboard swap , MC board has changed e.t.c',
  'JobCancelled': 'Task was cancelled by a user before it was delivered to the device.',
  'JobTimeOut': 'Task timed out before it was delivered to the device.'
};

export const OTA_BED_ERROR = {
  'No Response': 'Bed is Online but no Status is Retrievable after pushing the OTA job.',
  'Bed AC Unplugged': 'Bed AC is Unplugged.',
  'Bed OffLine': 'Selected Bed is Offline.',
  'UnzipOrManifestParsingError': 'Unzip Or Manifest Parsing Error',
  "NoError": "No Error",
  "InvalidPackageUrlError": "Invalid Package Url Error",
  "PackageDownloadFailedError": "Package Download Failed Error",
  "UnzipOrManifestParsingError": "Unzip Or Manifest Parsing Error",
  "DigitalSignatureVerificationFailedError": "Digital Signature Verification Failed Error",
  "SoftwareDowngradeFailedError": "Software Downgrade Failed Error",
  "SHA256ChecksumMismatchError": "SHA256 Checksum Mismatch Error",
  "GatewaySoftwareUpdateFailedError": "Gateway Software Update Failed Error",
  "GatewayInvalidVersionError": "Gateway Invalid Version Error",
  "PackageUnzipError": "Package Unzip Error",
  "SoftwareUpdateDownloadFailedThroughUsb": "Software Update Download Failed Through Usb",
  "SoftwareUpdateDownloadFailedThroughGw": "Software Update Download Failed Through Gw",
  "SoftwareUpdateInvalidUpdateFile": "Software Update Invalid Update File",
  "InvalidChecksumSha256": "Invalid Checksum Sha256",
  "InvalidSoftwareVersionFormat": "Invalid Software Version Format",
  "PackageNotUpgradeable": "Package Not Upgradeable",
  "DisplayUpdateUpdateWriteFailed": "Display Update Update Write Failed",
  "MainControllerUpdatePrepareForBootloaderTimeout": "Main Controller Update Prepare For Bootloader Timeout",
  "ZoomControllerUpdatePrepareForBootloaderTimeout": "Zoom Controller Update Prepare For Bootloader Timeout",
  "BrakeControllerUpdatePrepareForBootloaderTimeout": "Brake Controller Update Prepare For Bootloader Timeout",
  "RoomInterfaceBedUpdatePrepareForBootloaderTimeout": "Room Interface Bed Update Prepare For Bootloader Timeout",
  "MainControllerUpdateUpdateTargetCommunicationError": "Main Controller Update Update Target Communication Error",
  "MotionControllerUpdateUpdateTargetCommunicationError": "Motion Controller Update Update Target Communication Error",
  "ZoomControllerUpdateUpdateTargetCommunicationError": "Zoom Controller Update Update Target Communication Error",
  "BrakeControllerUpdateUpdateTargetCommunicationError": "Brake Controller Update Update Target Communication Error",
  "RoomInterfaceBedUpdateUpdateTargetCommunicationError": "Room Interface Bed Update Update Target Communication Error",
  "GatewayControllerUpdateUpdateTargetCommunicationError": "Gateway Controller Update Update Target Communication Error",
  "MainControllerUpdateJumpToAppError": "Main Controller Update Jump To App Error",
  "MotionControllerUpdateJumpToAppError": "Motion Controller Update Jump To App Error",
  "ZoomControllerUpdateJumpToAppError": "Zoom Controller Update Jump To App Error",
  "BrakeControllerUpdateJumpToAppError": "Brake Controller Update Jump To App Error",
  "RoomInterfaceBedUpdateJumpToAppError": "Room Interface Bed Update Jump To App Error",
  "BootloaderUpdateFailedError": 'Bootloader Update Error',
  "BootloaderChecksumMismatch": "Bootloader Checksum Mismatch",
  "BootloaderFileMissingManifest": "Bootloader File Missing Manifest",
  "BootloaderChecksumMissing": "Bootloader Checksum Missing",
  "GatewayUpdateError": "Gateway Update Error",
}

export const OTA_BED_STATUS_MAPPER = {
  'Idle': 'Gateway Idle',
  'DownloadSuccess': 'Download Success',
  'DownloadFailed': 'Download Failed',
  'Staging': 'Gateway Staging',
  'BedStaging': 'Bed Staging',
  'BedIdle': 'Bed Idle',
  'UserAckAwaited': 'User Ack Awaited',
  'CortexNodesUpdating': 'Cortex Nodes Updating',
  'GatewayUpdating': "Gateway Updating",
  'GatewayUpdateError': "Gateway Update Error",
  'DisplayUpdating': 'Display Updating',
  'ProductUpdateReboot': 'Product Update Reboot',
  'ProductUpdateSuccess': 'Product Update Success',
  'ProductUpdateFail': 'Product Update Failed',
  'GatewayRebooting': 'Gateway Rebooting',
  'GatewayUpdateSuccess': 'Gateway Update Success',
  'GatewayUpdateAbort': 'Gateway Update Abort',
  'UserAckAwaitedforRetry': 'User Ack Awaited for Retry',
  'BootloaderUpdateSucess': 'Gateway Update Success',
  'InvalidDeviceId': 'Invalid Device Id',
  'JobCancelled': 'Job Cancelled',
  'JobTimeOut': 'Job Timeout',
  'Delivery Canceled': 'Delivery Cancelled',
  'BedEnableRequestSent': 'Bed Enable Request Sent'
};

const OTA_BED_STATUS_MAPPER_LOWERCASE = Object.keys(OTA_BED_STATUS_MAPPER).reduce((acc, key) => {
  acc[key.toLowerCase()] = OTA_BED_STATUS_MAPPER[key];
  return acc;
}, {});

// Server status casing is inconsistent (e.g. 'InvalidDeviceID' vs 'InvalidDeviceId'), so match case-insensitively.
export const mapOtaBedStatus = (status) => {
  const trimmedStatus = String(status || '').trim();
  return OTA_BED_STATUS_MAPPER[trimmedStatus] || OTA_BED_STATUS_MAPPER_LOWERCASE[trimmedStatus.toLowerCase()] || trimmedStatus;
};

export const OTA_STATUS_COLOR_MAPPER = {
  // Best Case Statuses 
  'Scheduled': '#c0cbd1', // Light Grey
  'Queued': '#757575', // Darker Grey
  'Downloading': '#FFB300', // Amber
  'Download Success': '#4CAF50', // Standard Green
  'Gateway Staging': '#FF9800', // Orange
  'Gateway Updating': '#0288D1', // Light Blue
  'Gateway Rebooting': '#7E57C2', // Soft Purple
  'Gateway Update Success': '#66BB6A', // Medium Green
  'Gateway Idle': '#BDBDBD', // Light Grey
  'Bed Staging': '#FBC02D', // Golden Yellow
  'Bed Idle': '#9E9E9E', // Standard Grey
  'User Ack Awaited': '#607D8B', // Blue-Grey (Action required by user)
  'User Ack Awaited for Retry': '#546E7A', // Muted Blue-Grey
  'Cortex Nodes Updating': '#00B5DA', // Cyan (Your primary brand color)
  'Display Updating': '#03A9F4', // Sky Blue
  'Product Update Reboot': '#673AB7', // Deep Purple (Significant state change)
  'Product Update Success': '#2E7D32', // Dark Green

  // FAILURE STATES (Reds) ---
  'Download Failed': '#E53935', // Bright Red
  'Product Update Failed': '#B71C1C',  // Maroon/Blood Red
  'Delivery Cancelled': '#E65100', // Deep Orange
  'Gateway Update Abort': '#742d2d', // Deep red
  'Gateway Update Error': '#D32F2F', // Red for errors
  'Invalid Device Id': '#8e1414',
  'Job Cancelled': '#E65100', // Deep Orange (mirrors Delivery Canceled)
  'JobTimeOut': '#E65100',
  'Job Timeout': '#E65100',
}

// Device statuses — device is no longer in-progress; re-enable is valid from these states
export const OTA_TERMINAL_STATUSES = [
  'BedIdle', 'ProductUpdateSuccess', 'ProductUpdateFail',
  'DownloadFailed', 'Delivery Canceled', 'GatewayError', 'Succeeded',
  'GatewayUpdateAbort', 'InvalidDeviceId', 'JobCancelled', 'JobTimeOut', 'Idle', 'GatewayUpdateSuccess'
];

// Actively-processing statuses — device is mid-flight and should not be counted as stalled
export const OTA_ACTIVELY_PROCESSING_STATUSES = [
  'Scheduled', 'Queued', 'Downloading', 'Delivery Success', 'DownloadSuccess', 'BedEnableRequestSent'
];

// Tooltips for the three tabs in the Attention Required modal
export const ATTENTION_MODAL_TAB_TOOLTIPS = {
  UNAVAILABLE: 'Lists the Beds currently Queued (due to Bed Offline) or active OTA update in another job.',
  USER_ACK: 'Lists the Beds which are waiting for a user to acknowledge the update on the Bed Display.',
  STALLED: 'Lists the Beds whose statuses are not moving for more than an hour after the OTA package delivered to Bed. To avail the Bed for retrying update in a new OTA job, try Send Enable Bed Request.',
};
export const SKIPPED_DEVICES_MESSAGES = {
  OTA: {
    titlePreview: 'Devices Already Up-To-Date (Skipped)',
    titlePostSubmit: 'Devices Skipped From Job',
    skippedBadgeLabel: 'Already up-to-date',
    skippedBadgeTooltip: 'These devices already run the selected package version and will not be included in the job.',
    remainingBadgeLabel: 'Pending update',
    remainingBadgeTooltipHas: 'These devices require the update and will be included in the job.',
    remainingBadgeTooltipNone: 'No devices require this update. The job cannot be submitted.',
    infoRemainingVerb: 'will proceed with the update',
    infoSkippedState: 'already on the target version',
    infoTextWarnNone: 'All selected devices are already running the target package version. No update is required \u2014 the job cannot be submitted. Please select a different package or add devices that need updating.',
    skippedTabLabel: 'Already Up-To-Date',
    remainingTabLabel: 'Pending Update',
    skippedTabHint: 'These devices already match the selected package version and have been excluded from the job.',
    remainingTabHintHas: 'These devices require the update and will be included in the job upon submission.',
    remainingTabHintNone: 'No devices remain for this update. Review your device selection or choose a different package.'
  },
  Configuration: {
    titlePreview: 'Devices Already Configured (Skipped)',
    titlePostSubmit: 'Devices Skipped From Job',
    skippedBadgeLabel: 'Already configured',
    skippedBadgeTooltip: 'These devices already have the selected configuration and will not be included in the job.',
    remainingBadgeLabel: 'Pending configuration',
    remainingBadgeTooltipHas: 'These devices need the configuration change and will be included in the job.',
    remainingBadgeTooltipNone: 'No devices need this configuration change. The job cannot be submitted.',
    infoRemainingVerb: 'will be updated with the new configuration',
    infoSkippedState: 'already configured with the requested settings',
    infoTextWarnNone: 'All selected devices already have the requested configuration. No change is required \u2014 the job cannot be submitted. Please change the configuration or add devices that need updating.',
    skippedTabLabel: 'Already Configured',
    remainingTabLabel: 'Pending Configuration',
    skippedTabHint: 'These devices already have the selected configuration and have been excluded from the job.',
    remainingTabHintHas: 'These devices need the configuration change and will be included in the job upon submission.',
    remainingTabHintNone: 'No devices remain for this configuration. Review your device selection or change the configuration.'
  }
};

export const ENABLE_BED_REQUEST_TOOLTIP = {
  'Delivery Success': 'Bed Enabled request sent',
  'Bed Idle': 'Bed Enabled successful',
  'BedEnableRequestSent': 'Bed Enable Request Sent to device.',
}
